// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export function getGlobalObject() {
    return self;
}
//# sourceMappingURL=global.browser.js.map